module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/articles/feed/rssmanager/rssmanager.component.css
// module id = ./src/app/articles/feed/rssmanager/rssmanager.component.css
// module chunks = main